import { RoleBasedComponent } from '@/utils/RoleBasedComponent';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import MobileMenu from './MobileMenu';
import Navigation from './Navigation';
const Sidebar = () => {
  const [currentRoute, setCurrentRoute] = useState('');
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setCurrentRoute(location.pathname);
  }, [location]);

  const handleNavigate = (route: string) => {
    navigate(route);
  };

  return (
    <>
      <div className='hidden md:flex md:w-[269px] z-40  p-8  flex-col gap-4 md:fixed h-screen bg-white font-normal text-[14px]'>
        <div className='h-20 -mt-8 '>
          <img src='/assets/icons/Hillal.svg' alt='logo' />
        </div>

        <Navigation />
      </div>

      <div className='md:hidden'>
        <MobileMenu />
      </div>
    </>
  );
};

export default Sidebar;
